import { fromJS, Map } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'
import { CLEAR_PLANS as PLAN_CLEAR_PLANS } from '../PlanSelection/constants'
import { CLEAR_PLANS as QUICKSELECT_CLEAR_PLANS } from '../QuickSelect/constants'
import { CLEAR_PLANS as FOLDER_CLEAR_PLANS } from '../FolderSelectBox/constants'
import { isEmpty } from 'lodash'

const initialState = fromJS({
  detailedPins: {},
  templatesProjects: {},
  sharedReportUrls: {}
})

function reportsReducer (state = initialState, action) {
  let newState = state

  switch (action.type) {
    case actionTypes.UPLOAD_TEMPLATE:
      return state
        .set('uploadingTemplate', true)
        .delete('uploadTemplateError')
        .delete('uploadedTemplate')
        .delete('uploadingTemplateCancel')
    case actionTypes.UPLOAD_TEMPLATE_DONE:
      return state
        .set('uploadingTemplate', false)
        .set('uploadedTemplate', action.template)
    case actionTypes.UPLOAD_TEMPLATE_ERROR:
      return state
        .set('uploadingTemplate', false)
        .set('uploadTemplateError', action.error)
    case actionTypes.SET_UPLOAD_TEMPLATE_CANCEL:
      return state.set('uploadingTemplateCancel', action.source)
    case actionTypes.CANCEL_UPLOAD_TEMPLATE:
      state.get('uploadingTemplateCancel').cancel('Template upload canceled')
      return state.delete('uploadingTemplateCancel')

    case actionTypes.GET_TEMPLATES:
      return state.set('gettingTemplates', true).delete('getTemplatesError')
    case actionTypes.GET_TEMPLATES_DONE:
      return state
        .set('gettingTemplates', false)
        .setIn(['reportTemplates', action.page], action.templates)
    case actionTypes.GET_TEMPLATES_ERROR:
      return state
        .set('gettingTemplates', false)
        .set('getTemplatesError', action.error)
    case actionTypes.CLEAR_REPORT_TEMPLATES:
      return state
        .delete('reportTemplates')
        .delete('getTemplatesError')
        .delete('gettingTemplates')

    case actionTypes.GET_TEMPLATES_MANAGEMENT:
      return state
        .set('gettingTemplatesManagement', true)
        .delete('getTemplatesManagementError')
    case actionTypes.GET_TEMPLATES_MANAGEMENT_DONE:
      return state
        .set('gettingTemplatesManagement', false)
        .set('reportTemplatesManagement', action.templates.content)
    case actionTypes.GET_TEMPLATES_MANAGEMENT_ERROR:
      return state
        .set('gettingTemplatesManagement', false)
        .set('getTemplatesManagementError', action.error)
    case actionTypes.CLEAR_REPORT_TEMPLATES_MANAGEMENT:
      return state
        .delete('reportTemplatesManagement')
        .delete('getTemplatesManagementError')
        .delete('gettingTemplatesManagement')

    case actionTypes.UPDATE_TEMPLATE:
      return state
        .set('updatingTemplate', true)
        .delete('updateTemplateError')
        .delete('formatTemplateErrors')
    case actionTypes.UPDATE_TEMPLATE_DONE:
      if (action.name && newState.has('reportTemplates')) {
        let templateIndex = -1
        const page = newState.get('reportTemplates').findKey(({ content }) => {
          templateIndex = content.findIndex(
            ({ id }) => id === action.templateId
          )
          return templateIndex !== -1
        })
        if (![templateIndex, page].includes(-1)) {
          const templatePage = newState.getIn(['reportTemplates', page])
          templatePage.content[templateIndex] = {
            ...templatePage.content[templateIndex],
            name: action.name
          }
          newState = newState.mergeIn(['reportTemplates', page], templatePage)
        }
      }
      return newState.set('updatingTemplate', false)
    case actionTypes.UPDATE_TEMPLATE_ERROR:
      return state
        .set('updatingTemplate', false)
        .set('updateTemplateError', action.error)
    case actionTypes.FORMAT_TEMPLATE_ERRORS:
      return state
        .set('updatingTemplate', false)
        .set('formatTemplateErrors', action.errors)
    case actionTypes.CLEAR_UPDATE_TEMPLATE_STORE:
      return state
        .delete('formatTemplateErrors')
        .delete('updateTemplateError')
        .set('updatingTemplate', false)

    case actionTypes.DELETE_TEMPLATES:
      return state.set('deletingTemplate', true).delete('deleteTemplatesError')
    case actionTypes.DELETE_TEMPLATES_DONE:
      return state.set('deletingTemplate', false)
    case actionTypes.DELETE_TEMPLATES_ERROR:
      return state
        .set('deletingTemplate', false)
        .set('deleteTemplatesError', action.error)

    case actionTypes.GET_TEMPLATES_PROJECTS:
      if (action.page === 0) {
        newState = newState.set('templatesProjects', fromJS({}))
      }

      return newState
        .set('gettingTemplatesProjects', true)
        .delete('getTemplatesProjectsError')
    case actionTypes.GET_TEMPLATES_PROJECTS_DONE:
      return state
        .set('gettingTemplatesProjects', false)
        .setIn(['templatesProjects', action.page], action.projects)
    case actionTypes.GET_TEMPLATES_PROJECTS_ERROR:
      return state
        .set('gettingTemplatesProjects', false)
        .set('getTemplatesProjectsError', action.error)
    case actionTypes.CLEAR_TEMPLATES_PROJECTS_ERROR:
      return state
        .delete('gettingTemplatesProjects')
        .delete('getTemplatesProjectsError')
        .delete('templatesProjects')
    case PLAN_CLEAR_PLANS:
    case QUICKSELECT_CLEAR_PLANS:
    case FOLDER_CLEAR_PLANS:
      return state
        .delete('reportTemplatesOfProjectManagement')
        .delete('getTemplatesOfProjectManagementError')
        .delete('gettingTemplatesOfProjectManagement')

    case actionTypes.ASSIGN_TEMPLATES_TO_PROJECT:
      return state
        .set('assigningTemplatesToProject', true)
        .delete('assignTemplatesToProjectError')
    case actionTypes.ASSIGN_TEMPLATES_TO_PROJECT_DONE:
      return state.set('assigningTemplatesToProject', false)
    case actionTypes.ASSIGN_TEMPLATES_TO_PROJECT_ERROR:
      return state
        .set('assigningTemplatesToProject', false)
        .set('assignTemplatesToProjectError', action.error)

    // reports
    case actionTypes.GET_REPORTS:
      return state.set('gettingReports', true).delete('getReportsError')
    case actionTypes.GET_REPORTS_DONE:
      return state
        .set('gettingReports', false)
        .setIn(['reports', action.page], action.reports)
    case actionTypes.GET_REPORTS_ERROR:
      return state
        .set('gettingReports', false)
        .set('getReportsError', action.error)
    case actionTypes.CLEAR_REPORTS:
      return state
        .delete('reports')
        .delete('getReportsError')
        .delete('gettingReports')

    case actionTypes.CREATE_REPORT:
      return state
        .set('creatingReport', true)
        .delete('createReportError')
        .set('lastCreatedReportId', null)
    case actionTypes.CREATE_REPORT_DONE: {
      const page = action.page || 0
      const reports = state.getIn(['reports', page])

      // update report page if its open
      if (reports && reports.content) {
        reports.content.unshift(action.report)
        reports.numberOfElements = reports.numberOfElements
          ? reports.numberOfElements + 1
          : 1
        reports.totalElements = reports.totalElements
          ? reports.totalElements + 1
          : 1
      }

      return state
        .set('creatingReport', false)
        .setIn(['createdReport', action.report.id], action.report)
        .setIn(['reports', page], reports)
        .set('lastCreatedReportId', action.report.id)
    }
    case actionTypes.CREATE_REPORT_ERROR:
      return state
        .set('creatingReport', false)
        .set('createReportError', action.error)

    case actionTypes.GET_CREATED_REPORT:
      return state
        .set('gettingCreatedReport', true)
        .delete('getCreatedReportError')
    case actionTypes.GET_CREATED_REPORT_DONE: {
      const createdReport = state.get('createdReport')
      const page = action.page || 0

      if (action && !isEmpty(action.report) && createdReport[action.report.id]) {
        createdReport[action.report.id] = action.report
      }
      const reports = state.getIn(['reports', page])

      // update report page if its open
      if (reports && reports.content) {
        reports.content = reports.content.map((report) => {
          if (report.id === action.report.id) {
            return action.report
          }
          return report
        })
      }

      return state
        .setIn(['createdReport', action.report.id], action.report)
        .setIn(['reports', page], reports)
        .set('gettingCreatedReport', false)
    }

    case actionTypes.GET_CREATED_REPORT_ERROR:
      return state
        .set('gettingCreatedReport', false)
        .set('getCreatedReportError', action.error)
    case actionTypes.DELETE_CREATED_REPORT:
      return state.deleteIn(['createdReport', action.reportId])

    case actionTypes.ENABLE_SHARE_REPORT:
      return state.set('enablingShareReport', true)
    case actionTypes.ENABLE_SHARE_REPORT_DONE:
      return state
        .set('enablingShareReport', false)
        .setIn(['sharedReportUrls', action.report.id], action.report.shareUrls)
    case actionTypes.ENABLE_SHARE_REPORT_ERROR:
      return state
        .set('enablingShareReport', false)
        .set('enableShareReportError', action.error)
    case actionTypes.CLEAR_SHARE_REPORT_ERROR:
      return state.delete('enableShareReportError')
    case actionTypes.GET_TEMPLATES_OF_PROJECT_MANAGEMENT:
      return state
        .set('gettingTemplatesOfProjectManagement', true)
        .delete('getTemplatesOfProjectManagementError')
    case actionTypes.GET_TEMPLATES_OF_PROJECT_MANAGEMENT_DONE:
      return state
        .set('gettingTemplatesOfProjectManagement', false)
        .set('reportTemplatesOfProjectManagement', action.templates)
    case actionTypes.GET_TEMPLATES_OF_PROJECT_MANAGEMENT_ERROR:
      return state
        .set('gettingTemplatesOfProjectManagement', false)
        .set('getTemplatesOfProjectManagementError', action.error)
    case actionTypes.CLEAR_REPORT_TEMPLATES_OF_PROJECT_MANAGEMENT:
      return state
        .delete('reportTemplatesOfProjectManagement')
        .delete('getTemplatesOfProjectManagementError')
        .delete('gettingTemplatesOfProjectManagement')

    case actionTypes.CLEAR_DETAILED_PINS:
      return state.set('detailedPins', new Map())
    case actionTypes.GET_DETAILED_PROJECT_PINS:
      return state.set('loadingDetailedPins', true)
    case actionTypes.GET_DETAILED_PINS_DONE:
      return state
        .set('loadingDetailedPins', false)
        .setIn(['detailedPins', action.page], action.pins)
    case actionTypes.GET_DETAILED_PINS_ERROR:
      return state
        .set('loadingDetailedPins', false)
        .set('getDetailedPinsError', action.error)

    case actionTypes.CREATE_FILTER:
      return state.set('creatingFilter', true).set('createFilterError', null)
    case actionTypes.CREATE_FILTER_DONE:
      return state.set('creatingFilter', false).set('filterId', action.filterId)
    case actionTypes.CREATE_FILTER_ERROR:
      return state
        .set('creatingFilter', false)
        .set('createFilterError', action.error)

    case actionTypes.GET_ATTENDEES_LIST_DONE:
      return state
        .set('attendees', action.attendees)
        .delete('createReportError')
    case actionTypes.GET_ATTENDEES_LIST_ERROR:
      return state.set('createReportError', action.error)

    case actionTypes.GET_WEATHER_DATE_DONE:
      return state
        .set('weatherDate', action.weatherDate)
        .delete('createReportError')
    case actionTypes.GET_WEATHER_DATE_ERROR:
      return state.set('createReportError', action.error)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reportsReducer
